import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { messages } from '../lang';

Vue.use(VueI18n);

let locale = localStorage.getItem('lang');

if (!locale) {
  // Use /g — String.replace with a string only swaps the first hyphen,
  // which breaks multi-segment tags like zh-Hant-TW (would become
  // zh_Hant-TW and fall through to the Russian default).
  locale = navigator.language.replace(/-/g, '_').toLocaleLowerCase();
}

// If the browser sends a region-qualified locale (e.g. de_at, en_gb) and
// only the base language exists in our bundles, accept the base. Without
// this step `de_at` would fall through to the Russian default below.
if (locale && !(locale in messages) && locale.includes('_')) {
  const base = locale.split('_')[0];
  if (base in messages) {
    locale = base;
  }
}

// Corporate brand (ZetaPilot) defaults to Russian when no preference is set
// and the browser also doesn't request a known locale.
if (!locale || !(locale in messages)) {
  locale = 'ru';
}

export default new VueI18n({
  fallbackLocale: 'en',
  locale,
  messages,
  silentFallbackWarn: true,
});
